/** Imperatively show/hide Bootstrap export modals (BS5 + jQuery fallback). */
export function showExportModal(modalId) {
  const el = document.getElementById(modalId);
  if (!el) return false;
  if (window.bootstrap?.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(el).show();
    return true;
  }
  if (window.$) {
    window.$(el).modal("show");
    return true;
  }
  return false;
}

export function hideExportModal(modalId) {
  const el = document.getElementById(modalId);
  if (!el) return;
  if (window.bootstrap?.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(el).hide();
    return;
  }
  if (window.$) {
    window.$(el).modal("hide");
  }
}

/** Close mobile downloads sheet, then open export modal (same pattern as wallet transfer). */
export function hideThenShowExport(downloadSheetSelector, exportModalId, delayMs = 320) {
  const dlEl = document.querySelector(downloadSheetSelector);
  const dlWrap = dlEl?.closest(".modal");
  if (dlWrap && window.bootstrap?.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(dlWrap).hide();
  } else if (dlWrap && window.$) {
    window.$(dlWrap).modal("hide");
  }
  window.setTimeout(() => {
    showExportModal(exportModalId);
  }, delayMs);
}

export function downloadUtf8Csv(filename, csvBody) {
  const blob = new Blob(["\ufeff", csvBody], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener noreferrer";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  const cleanup = () => {
    if (a.parentNode) document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  setTimeout(cleanup, 2500);
}

function parseLocalYmd(ymd) {
  const [y, m, d] = String(ymd || "").split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

function formatLocalYmd(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Split inclusive local-date range into chunks (for batch CSV export). */
export function splitLocalDateRangeIntoChunks(from, to, chunkDays = 30) {
  const start = parseLocalYmd(from);
  const end = parseLocalYmd(to);
  if (!start || !end || start > end) return [];

  const chunks = [];
  let cursor = new Date(start);
  while (cursor <= end) {
    const chunkEnd = new Date(cursor);
    chunkEnd.setDate(chunkEnd.getDate() + Math.max(1, chunkDays) - 1);
    if (chunkEnd > end) chunkEnd.setTime(end.getTime());
    chunks.push({ from: formatLocalYmd(cursor), to: formatLocalYmd(chunkEnd) });
    cursor = new Date(chunkEnd);
    cursor.setDate(cursor.getDate() + 1);
  }
  return chunks;
}
